import React from "react";
import { useTranslation } from "react-i18next";

import { isCoach } from "enefel/index";
import { AiFillStar } from "react-icons/ai";
import CustomTooltip from "../Interface/Tooltip";

type PlayerIsCoachProps = {
  player: any;
  team?: any;
};

const PlayerIsCoach: React.FC<PlayerIsCoachProps> = React.memo(
  ({ player, team }) => {
    const { t } = useTranslation();
    return isCoach(player, team) ? (
      <CustomTooltip placement="top" title={t("t:Coach", "__Coach")}>
        <span>
          <AiFillStar style={{ color: "yellow" }} />
        </span>
      </CustomTooltip>
    ) : null;
  }
);

export default PlayerIsCoach;
